/**
 * API методы для настроек Telegram бота: CRUD автоответов, настройки бота
 * Дата: 29.12.2025 - Добавлена поддержка tenantId для SuperAdmin
 */
import { apiClient } from './client';
import { AutoReplyRule } from './types';

export const botApi = {
  getAutoReplies: async (tenantId?: string): Promise<{ rules: AutoReplyRule[] }> => {
    const headers = tenantId ? { 'X-Tenant-ID': tenantId } : {};
    const response = await apiClient.get('/bot/auto-replies', { headers });
    return response.data;
  },

  createAutoReply: async (rule: Omit<AutoReplyRule, 'id'>, tenantId?: string): Promise<AutoReplyRule> => {
    const headers = tenantId ? { 'X-Tenant-ID': tenantId } : {};
    const response = await apiClient.post('/bot/auto-replies', rule, { headers });
    return response.data;
  },

  updateAutoReply: async (id: string, rule: Partial<AutoReplyRule>, tenantId?: string): Promise<AutoReplyRule> => {
    const headers = tenantId ? { 'X-Tenant-ID': tenantId } : {};
    const response = await apiClient.put(`/bot/auto-replies/${id}`, rule, { headers });
    return response.data;
  },

  deleteAutoReply: async (id: string, tenantId?: string): Promise<void> => {
    const headers = tenantId ? { 'X-Tenant-ID': tenantId } : {};
    await apiClient.delete(`/bot/auto-replies/${id}`, { headers });
  },

  getSettings: async (tenantId?: string) => {
    const headers = tenantId ? { 'X-Tenant-ID': tenantId } : {};
    const response = await apiClient.get('/bot/settings', { headers });
    return response.data;
  },

  updateSettings: async (settings: any, tenantId?: string) => {
    const headers = tenantId ? { 'X-Tenant-ID': tenantId } : {};
    const response = await apiClient.put('/bot/settings', settings, { headers });
    return response.data;
  },
};

